"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Calendar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _reactDayPicker = _interopRequireDefault(require("react-day-picker"));

var _luxon = require("luxon");

var _DateTimeHelper = _interopRequireDefault(require("../utils/DateTimeHelper"));

var _CalendarHelper = _interopRequireDefault(require("../utils/CalendarHelper"));

var _dataAids = _interopRequireDefault(require("../constants/dataAids"));

var _dateTimeFormatter = require("../constants/propTypes/dateTimeFormatter");

var _timeZone = require("../constants/propTypes/timeZone");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var daySizeMobileStyles = {
  width: '2rem',
  height: '2rem',
  lineHeight: '2rem'
};
var daySizeDesktopStyles = {
  width: '2.5rem',
  height: '2.5rem',
  lineHeight: '2.5rem'
};
var wrapperStyles = {
  position: 'relative'
};

var Calendar = /*#__PURE__*/function (_Component) {
  _inherits(Calendar, _Component);

  var _super = _createSuper(Calendar);

  function Calendar(props) {
    var _this;

    _classCallCheck(this, Calendar);

    _this = _super.call(this, props);
    _this.onDayClick = _this.onDayClick.bind(_assertThisInitialized(_this));
    _this.onMonthChange = _this.onMonthChange.bind(_assertThisInitialized(_this));
    _this.renderWeekday = _this.renderWeekday.bind(_assertThisInitialized(_this));
    _this.state = {
      jsSelectedDay: _CalendarHelper["default"].getCalendarToday(props.timeZone),
      calendarModifiers: {}
    };
    return _this;
  }

  _createClass(Calendar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.highlightedDays !== prevProps.highlightedDays) {
        this.calculateCalendarModifiers();
      }
    }
  }, {
    key: "convertToClassNames",
    value: function convertToClassNames(style) {
      return this.getRenderedClassNames(_guacWidgetCore.UX2.Element.Element, {
        style: style
      });
    }
  }, {
    key: "getRenderedClassNames",
    value: function getRenderedClassNames(ElementComponent) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var el = new ElementComponent(props, this.context);
      var instance = el.render ? el.render() : el;
      return typeof instance.type === 'function' ? this.getRenderedClassNames(instance.type, instance.props) : instance.props.className || '';
    }
  }, {
    key: "onDayClick",
    value: function onDayClick(jsDay, _ref) {
      var disabled = _ref.disabled;
      var _this$props = this.props,
          onDayClick = _this$props.onDayClick,
          timeZone = _this$props.timeZone;

      if (disabled) {
        return;
      }

      this.setState({
        jsSelectedDay: jsDay
      }, function () {
        return onDayClick(_DateTimeHelper["default"].changeTz(_luxon.DateTime.fromJSDate(jsDay), timeZone));
      });
    }
  }, {
    key: "onMonthChange",
    value: function onMonthChange(jsDay) {
      var _this$props2 = this.props,
          onDayClick = _this$props2.onDayClick,
          timeZone = _this$props2.timeZone;

      var luxonDate = _luxon.DateTime.fromJSDate(jsDay);

      var merchantMonth = _CalendarHelper["default"].getMerchantMonth(timeZone);

      var jsEarliestDayOfMonth = merchantMonth.hasSame(luxonDate, 'month') && merchantMonth.hasSame(luxonDate, 'year') ? _CalendarHelper["default"].getCalendarToday(timeZone) : _luxon.DateTime.fromJSDate(jsDay).startOf('month').toJSDate();
      this.setState({
        jsSelectedDay: jsEarliestDayOfMonth,
        calendarModifiers: {}
      }, function () {
        return onDayClick(_DateTimeHelper["default"].changeTz(_luxon.DateTime.fromJSDate(jsEarliestDayOfMonth), timeZone));
      });
      this.props.onMonthChange(_DateTimeHelper["default"].changeTz(_luxon.DateTime.fromJSDate(jsDay), timeZone));
    }
  }, {
    key: "renderWeekday",
    value: function renderWeekday(_ref2) {
      var weekday = _ref2.weekday,
          className = _ref2.className;
      var dateTimeFormatter = this.props.dateTimeFormatter;
      var weekdayName = dateTimeFormatter.getWeekdayName(weekday, true);
      var Block = _guacWidgetCore.UX2.Element.Block;
      return /*#__PURE__*/_react["default"].createElement(Block, {
        className: className,
        title: weekdayName
      }, weekdayName);
    }
  }, {
    key: "renderNavbar",
    value: function renderNavbar(_ref3) {
      var onPreviousClick = _ref3.onPreviousClick,
          onNextClick = _ref3.onNextClick,
          className = _ref3.className;
      var _UX2$Element = _guacWidgetCore.UX2.Element,
          Block = _UX2$Element.Block,
          Icon = _UX2$Element.Icon;
      var arrowStyles = {
        position: 'absolute',
        top: '0px',
        width: '1.75em',
        textAlign: 'center',
        cursor: 'pointer',
        color: 'highContrast'
      };
      var styles = {
        arrowLeft: _objectSpread({}, arrowStyles, {
          left: '0px'
        }),
        arrowRight: _objectSpread({}, arrowStyles, {
          right: '0px'
        })
      };
      return /*#__PURE__*/_react["default"].createElement(Block, {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(Block, {
        onClick: function onClick() {
          return onPreviousClick();
        },
        style: styles.arrowLeft
      }, /*#__PURE__*/_react["default"].createElement(Icon, {
        icon: "chevronLeft",
        size: "medium",
        "data-aid": _dataAids["default"].CALENDAR_CHEVRON_LEFT
      })), /*#__PURE__*/_react["default"].createElement(Block, {
        onClick: function onClick() {
          return onNextClick();
        },
        style: styles.arrowRight
      }, /*#__PURE__*/_react["default"].createElement(Icon, {
        icon: "chevronRight",
        size: "medium",
        "data-aid": _dataAids["default"].CALENDAR_CHEVRON_RIGHT
      })));
    }
    /**
     * - Expects highlightedDays (available dates) to be sorted in order.
     * - Avoids looping through every single element in highlightedDays array per day in month.
     * - Avoids re-calculating per re-render (day clicks).
     * - Returns highlighted + non-highlighted days in separate arrays as browser js dates to
     *   pass to React Daypicker.
     */

    /* eslint-disable max-statements */

  }, {
    key: "calculateCalendarModifiers",
    value: function calculateCalendarModifiers() {
      var _this$props3 = this.props,
          highlightedDays = _this$props3.highlightedDays,
          timeZone = _this$props3.timeZone;
      var jsSelectedDay = this.state.jsSelectedDay;
      var calendarModifiers = {
        highlighted: [],
        nonHighlighted: []
      };
      var browserTimeZone = new _luxon.IANAZone(_luxon.DateTime.local().zoneName);

      var startDate = _luxon.DateTime.max(_luxon.DateTime.fromJSDate(_CalendarHelper["default"].getCalendarToday(timeZone)), _luxon.DateTime.fromJSDate(jsSelectedDay).startOf('month'));

      var luxonDate = _DateTimeHelper["default"].changeTz(startDate, timeZone);

      var luxonMonthEnd = luxonDate.endOf('month');
      var highlightIndex = 0;
      var highlightedDay = highlightedDays[highlightIndex];

      while (luxonDate < luxonMonthEnd) {
        var jsDate = _DateTimeHelper["default"].changeTz(luxonDate, browserTimeZone).toJSDate();

        if (highlightedDay && _luxon.DateTime.fromISO(highlightedDay, {
          zone: timeZone
        }).hasSame(luxonDate, 'day')) {
          calendarModifiers.highlighted.push(jsDate);
          highlightedDay = highlightedDays[++highlightIndex];
        } else {
          calendarModifiers.nonHighlighted.push(jsDate);
        }

        luxonDate = luxonDate.plus({
          days: 1
        });
      }

      this.setState({
        calendarModifiers: calendarModifiers
      });
    }
    /* eslint-enable max-statements */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          timeZone = _this$props4.timeZone,
          maxFutureCalendarMonths = _this$props4.maxFutureCalendarMonths,
          dateTimeFormatter = _this$props4.dateTimeFormatter;
      var _this$state = this.state,
          jsSelectedDay = _this$state.jsSelectedDay,
          calendarModifiers = _this$state.calendarModifiers;
      var Block = _guacWidgetCore.UX2.Element.Block;
      var calStyles = {
        // The container element
        container: "calendar-container ".concat(this.convertToClassNames({
          userSelect: 'none',
          outline: 'none'
        })),
        // Added to the container when there's no interaction with the calendar
        interactionDisabled: "calendar-interactiondisabled ".concat(this.convertToClassNames({
          cursor: 'default'
        })),
        // The navigation bar with the arrows to switch between months
        navBar: "calendar-navbar ".concat(this.convertToClassNames({
          position: 'absolute',
          left: '0',
          right: '0',
          paddingVertical: 'none',
          paddingHorizontal: 'medium',
          zIndex: '2'
        })),
        // Button to switch to the previous month
        navButtonPrev: "calendar-navbar-prev ".concat(this.convertToClassNames({})),
        // Button to switch to the next month
        navButtonNext: "calendar-navbar-next ".concat(this.convertToClassNames({})),
        // The month's main tables
        month: "calendar-month ".concat(this.convertToClassNames({
          userSelect: 'none',
          position: 'relative',
          outline: 'none',
          color: 'highContrast'
        })),
        // The caption element, containing the current month's name and year
        caption: "calendar-caption ".concat(this.convertToClassNames({
          position: 'relative',
          height: '1.5rem',
          font: 'alt',
          textAlign: 'center'
        }), ")"),
        // Table header displaying the weekdays names
        weekdays: "calendar-weekdays ".concat(this.convertToClassNames({
          'position': 'relative',
          '@xs': {
            marginTop: 'xsmall'
          },
          '@sm': {
            marginTop: 'medium'
          }
        })),
        // Table row displaying the weekdays names
        weekdaysRow: "calendar-weekdays-row ".concat(this.convertToClassNames({
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          color: 'highContrast'
        })),
        // Cell displaying the weekday name
        weekday: "calendar-weekday ".concat(this.convertToClassNames(_objectSpread({}, daySizeMobileStyles, {
          'marginBottom': 'xxsmall',
          'font': 'alt',
          'fontSize': 'medium',
          'fontWeight': 'bold',
          'textAlign': 'center',
          '@sm': _objectSpread({
            marginVertical: 'xsmall'
          }, daySizeDesktopStyles)
        }))),
        // Table's body with the weeks
        body: "calendar-body ".concat(this.convertToClassNames({
          color: 'lowContrast'
        })),
        // Table's row for each week
        week: "calendar-week ".concat(this.convertToClassNames({
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        })),
        // The single day cell
        day: "calendar-day ".concat(this.convertToClassNames(_objectSpread({}, daySizeMobileStyles, {
          'marginVertical': 'xxsmall',
          'textAlign': 'center',
          'outline': 'none',
          '@sm': _objectSpread({
            marginVertical: 'xsmall'
          }, daySizeDesktopStyles)
        }))),
        // default modifiers
        // Added to the day's cell specified in the `selectedDays` prop
        selected: "calendar-selected ".concat(this.convertToClassNames({
          'backgroundColor': 'action',
          'textAlign': 'center',
          'color': 'action',
          'borderRadius': '50%'
        })),
        // Added to the day's cell specified in the `disabledDays` prop
        disabled: "calendar-disabled ".concat(this.convertToClassNames({
          cursor: 'default',
          pointerEvents: 'none'
        })),
        // Added to the day's cell outside the current month
        outside: "calendar-outside ".concat(this.convertToClassNames({
          cursor: 'default !important'
        })),
        today: 'calendar-today'
      };
      var modifierClassNames = {
        highlighted: this.convertToClassNames({
          'cursor': 'pointer',
          'borderRadius': '50%',
          'borderColor': 'primary',
          'borderStyle': 'solid',
          'borderWidth': '1px',
          ':not(.calendar-selected)': {
            'color': 'highContrast'
          }
        })
      };

      var merchantMonth = _CalendarHelper["default"].getMerchantMonth(timeZone);

      return /*#__PURE__*/_react["default"].createElement(Block, {
        style: wrapperStyles
      }, /*#__PURE__*/_react["default"].createElement(_reactDayPicker["default"], {
        "data-aid": _dataAids["default"].CALENDAR_DAY_PICKER_RENDERED,
        ref: function ref(_ref5) {
          return _this2.daypicker = _ref5;
        },
        classNames: calStyles,
        month: jsSelectedDay,
        fromMonth: merchantMonth.toJSDate(),
        toMonth: merchantMonth.plus({
          months: maxFutureCalendarMonths
        }).toJSDate(),
        onDayClick: this.onDayClick,
        onMonthChange: this.onMonthChange,
        selectedDays: jsSelectedDay,
        disabledDays: [{
          before: _CalendarHelper["default"].getCalendarToday(timeZone)
        }],
        weekdayElement: this.renderWeekday,
        navbarElement: this.renderNavbar,
        modifiers: _defineProperty({}, modifierClassNames.highlighted, calendarModifiers.highlighted),
        months: dateTimeFormatter.getMonthNames()
      }));
    }
  }]);

  return Calendar;
}(_react.Component);

exports.Calendar = Calendar;

_defineProperty(Calendar, "contextTypes", _guacWidgetCore.UX2.Base.contextTypes);

Calendar.propTypes = {
  dateTimeFormatter: _dateTimeFormatter.dateTimeFormatterPropType.isRequired,
  timeZone: _timeZone.timeZonePropType.isRequired,
  onDayClick: _propTypes["default"].func.isRequired,
  onMonthChange: _propTypes["default"].func.isRequired,
  maxFutureCalendarMonths: _propTypes["default"].number.isRequired,
  highlightedDays: _propTypes["default"].array.isRequired
};
var _default = Calendar;
exports["default"] = _default;